import CurrentUserService from './current-user-service';

/***
 * A Service used to track information about the user currently authenticated with the backend
 * server. Used to determine client-side permissions.
 */
const currentUser = angular
    .module('FacilityData.Common.CurrentUser', [])
    .service('CurrentUser', CurrentUserService)
    .name;

export default currentUser;


// WEBPACK FOOTER //
// ./app/common/current-user/current-user.js